import { render, staticRenderFns } from "./TempoExpirado.vue?vue&type=template&id=958c0388&scoped=true&"
import script from "./TempoExpirado.vue?vue&type=script&lang=js&"
export * from "./TempoExpirado.vue?vue&type=script&lang=js&"
import style0 from "./TempoExpirado.vue?vue&type=style&index=0&id=958c0388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958c0388",
  null
  
)

export default component.exports